import React, { Component } from 'react';

function ErrorMessage({ classNameError, errorAlt, errorMessage }) {
    return <div className={classNameError || "invalid-feedback d-block bg-danger p-1 rounded-lg text-white"}>
        {(errorAlt && errorAlt[errorMessage.type]) ?
            (errorAlt[errorMessage.type]) :
            (`${errorMessage.type}: ${errorMessage.message}`)}
    </div>;
}

export default class InputSelect extends Component {
    constructor(props) {
        super()
        this.state = {
            label: props.label || "",
            value: "",
            onFormat: props.format || this.format,
            keyField: props.keyField || "id",
        }
    }

    componentDidMount() {
        const { row, rows } = this.props;
        if (Object.keys(row).length > 0) {
            this.setState({ value: row[this.state.keyField] })
        }
        if (Array.isArray(rows) && rows.length > 0) {
            this.props.onChange(rows[0]);
        }
    }

    componentDidUpdate(prevProps) {
        const idChanged = this.props.row && prevProps.row && prevProps.row[this.state.keyField] !== this.props.row[this.state.keyField]
        const isArray = Array.isArray(prevProps.rows) && Array.isArray(this.props.rows);
        const preRows = JSON.stringify(prevProps.rows)
        const currentRows = JSON.stringify(this.props.rows)
        const rowsChanged = isArray && preRows !== currentRows;

        if (idChanged && this.props.row) {
            this.setState({ value: this.props.row[this.state.keyField] })
        }

        if (rowsChanged) {
            const [row] = this.props.rows
            this.props.onChange(row)
        }
    }

    format(selected) {
        return selected.descripcion;
    }

    render() {
        const { label, value, onFormat } = this.state;
        const { onChange, rows, classNameError, errorAlt, errorMessage } = this.props;
        return (
            <div className="form-group">
                <label className='d-block'>{label}</label>
                <select
                    readOnly={this.props.readOnly || false}
                    disabled={this.props.readOnly || false}
                    className={"form-control custom-select " + this.props.classSelect || ""}
                    value={value}
                    onChange={(event) => { this.onChange(event, onChange) }}
                >
                    {rows.map((row) => {
                        return (<option key={`${row[this.state.keyField]}`} value={row[this.state.keyField]}>{onFormat(row)}</option>);
                    })}
                </select>
                {errorMessage && (
                    <ErrorMessage classNameError={classNameError} errorAlt={errorAlt} errorMessage={errorMessage} />
                )}
                {this.props.children}
            </div>
        )
    }

    onChange(event, onChange) {
        const { value } = event.target;
        const rowFilter = this.props.rows.filter(el => {
            return String(el[this.state.keyField]) === String(value)
        })
        let row = {}
        if (rowFilter.length > 0) {
            row = rowFilter[0]
        }
        this.setState({ value: value });
        onChange && onChange(row);
    }
}